export default "__VITE_ASSET__ClsX9J7G__"